import { createRoot } from "react-dom/client";
import { App } from "./App";

// Noto Sans comes from Fontsource as plain same-origin files (served by serve.ts, copied by
// build.ts) rather than through the bundler, which would inline every subset as base64.
const font = document.createElement("link");
font.rel = "stylesheet";
font.href = "/fonts/noto-sans/index.css";
document.head.append(font);

createRoot(document.getElementById("root")!).render(<App />);
